export function Home() {
    return (
        <div className="emptyContent">
            <h1>Welcome!</h1>
        </div>
    );
}
